<template>
  <div class="label-task-info"
       v-if="taskInfo.result === 0">
    <el-card header="">
      <div slot="header"
           class="task-header">
        <span>任务进度</span>
        <el-button @click="deleteaddtagsegmenttask"
                   :disabled="taskInfo.status === 9"
                   type="text">{{ taskInfo.status === 9 ? '取消中' : '取消任务' }}</el-button>
      </div>
      <el-progress :text-inside="true"
                   :stroke-width="26"
                   :percentage="progress.percentage"
                   text-color="#ffffff"
                   :status="progress.status"
                   define-back-color="#ccc"></el-progress>
      <div class="error-tip"
           v-if="taskInfo.fail">
        <b>任务出错：</b>
        <span>{{ taskInfo.failInfo}}</span>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Label from '@/service/label'
export default {
  name: 'label-task-info',
  data () {
    return { loading: false, cancelLoading: false, fetching: false }
  },
  computed: {
    ...mapState({
      taskInfo: state => state.account.taskInfo
    }),
    progress ({ taskInfo }) {
      const { totalTaskCount, successTaskCount, result, fail } = taskInfo
      return {
        percentage: result === 0 ? +(successTaskCount / totalTaskCount * 100).toFixed(2) : 0,
        status: fail ? 'exception' : 'success'
      }
    }
  },
  mounted () {
    this.fetching = true
    this.getaddtagsegmenttaskinfo(true)
    this.$store.commit('account/setUpdateTask', this.updateInfo.bind(this))
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    this.fetching = false
    clearTimeout(this.tick)
    this.$store.commit('account/setUpdateTask', null)
  },
  methods: {
    updateInfo () {
      if (this.loading) {
        return
      }
      clearTimeout(this.tick)
      this.getaddtagsegmenttaskinfo(true)
    },
    getaddtagsegmenttaskinfo (isNext) {
      this.loading = true
      Label.getaddtagsegmenttaskinfo()
        .then(res => {
          const { result, message, data } = res.data
          if (result === 0) {
            const { totalTaskCount, successTaskCount, fail, failInfo, status } = data
            this.$store.commit('account/setTaskInfo', { totalTaskCount, successTaskCount, fail, failInfo, status, result })
          } else if (result === 13) {
            this.$store.commit('account/setTaskInfo', { result: 13, totalTaskCount: null, successTaskCount: null, fail: false, failInfo: '', status: null })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(() => {
          this.loading = false
          if (isNext && this.fetching) {
            console.log('tick')
            this.tick = setTimeout(() => {
              this.getaddtagsegmenttaskinfo(true)
            }, 5000)
          }
        })
    },
    deleteaddtagsegmenttask () {
      if (this.cancelLoading) {
        return
      }
      this.$confirm('此操作将取消未完成的标签生产任务, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.cancelLoading = true
          Label.deleteaddtagsegmenttask({ })
            .then(res => {
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('取消成功')
                setTimeout(() => {
                  this.updateInfo()
                }, 500)
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.$message.error(err.message)
            })
            .finally(() => {
              this.cancelLoading = false
            })
        })
    }
  }
}
</script>
<style lang="stylus">
.label-task-info {
  position: fixed;
  right: 20px;
  bottom: 8px;
  z-index: 2000;
  width: 180px;

  .task-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
  }

  .el-card__header {
    padding: 8px !important;
    font-size: 14px !important;
  }

  .el-card__body {
    padding: 8px !important;
  }

  .error-tip {
    font-size: 12px;
    color: #f56c6c;
    line-height: 16px;
    margin-top: 10px;
  }
}
</style>
